export const GET_COMPONENT_JSON: string = "GET_COMPONENT_JSON";
export const GET_COMPONENT_JSON_SUCCESS: string = "GET_COMPONENT_JSON_SUCCESS";
export const GET_COMPONENT_JSON_FAIL: string = "GET_COMPONENT_JSON_FAIL";
export const RESET_COMPONENT_JSON: string = "RESET_COMPONENT_JSON";
